import { Box, styled } from '@mui/material';

import { AvatarProps } from './Avatar.types';

const avatarPadding = 12;

export const AvatarContainer = styled(Box)(({ dimension }: AvatarProps) => ({
  width: `${dimension}px`,
  height: `${dimension}px`,
  padding: `${avatarPadding}px`,
}));

export const AvatarImage = styled('img')(
  ({ dimension, shadow }: AvatarProps) => ({
    width: `${dimension}px`,
    height: `${dimension}px`,
    objectFit: 'cover',
    borderRadius: '50%',
    objectPosition: '0% 70%',
    boxShadow: `${shadow ? `20px 40px 15px 4px ${shadow}` : ''}`,
  }),
);
